import { SiteConfig } from 'types'

const site_url = process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000'

export const siteConfig: SiteConfig = {
  title: 'Algochat.io - Ultimate AI Chatbots for Streamers',
  name: 'Algochat.io',
  description:
    'AI-powered ultimate chatbots for your streams with extensive customization options. Elevate audience engagement through interactive, intelligent, and dynamic chatbots with real-time interactions. Start for free today!',
  url: site_url,
  ogImage: `${site_url}/algo-landing.png`,
  links: {},
  mailSupport: 'hi@algochat.io',
  subscriptionPlans: {
    basic: {
      monthly: {
        id: 472810,
        variantId: 789594,
        name: 'Basic plan (Monthly)',
        price: '19.99$',
        planType: 'BASIC',
      },
      annual: {
        id: 472811,
        variantId: 789595,
        name: 'Basic plan (Annual)',
        price: '189.99$',
        planType: 'BASIC',
      },
    },
    premium: {
      monthly: {
        id: 472812,
        variantId: 789592,
        name: 'Premium plan (Monthly)',
        price: '39.99$',
        planType: 'PREMIUM',
      },
      annual: {
        id: 472813,
        variantId: 789593,
        name: 'Premium plan (Annual)',
        price: '380.99$',
        planType: 'PREMIUM',
      },
    },
  },
}

export const META_THEME_COLORS = {
  light: '#ffffff',
  dark: '#09090b',
}

export const subscriptionPlans = {
  FREE: 60 * 30, // 30 minutes
  BASIC: 60 * 60 * 6, // 6 hours
  PREMIUM: 60 * 60 * 24 * 30, // 30 days
}

export const messageLimits = {
  FREE: 2,
  BASIC: 10,
  PREMIUM: Infinity,
}

export const BLOG_CATEGORIES = [
  { value: 'twitch', label: 'Twitch' },
  { value: 'kick', label: 'Kick' },
  { value: 'youtube', label: 'Youtube' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'tiktok', label: 'Tiktok' },
  { value: 'strategy', label: 'Strategy' },
  { value: 'tips', label: 'Tips' },
  { value: 'guides', label: 'Guides' },
  { value: 'news', label: 'News' },
  { value: 'updates', label: 'Updates' },
]
